import { Base, PageObject } from '@testsigmainc/models';
import { serializable } from 'serializr';

export class IosWdaDetails extends Base implements PageObject {
  @serializable
  public wdaPresignedUrl: string;

  @serializable
  xcTestRemoteUrl: string;

  @serializable
  xcTestRunFileUrl: string;

  @serializable
  integrationAppUrl: string;
}
